import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToOne, OneToMany } from "typeorm";
import {CodeListStatus} from '@gtpl/shared-models/planning'
import { CodeListMain } from "../code-list-main/code-list-main.entity";
import { CodeListMainItems } from "../code-list-main/code-list-main-items.entity";
@Entity('code_list')
export class CodeList {
  @PrimaryGeneratedColumn("increment", { name: 'code_list_id' })
  codeListId: number;
  @Column("int", {
    nullable: true,
    name: "unit_id"
  })
  unitId: number;
  @Column("varchar", {
    length:20,
    nullable: true,
    name: "traceability_code"
  })
  traceabilityCode: string;
  @Column({
    type:'enum',
    // length:5,
    nullable: true,
    enum:CodeListStatus,
    default:CodeListStatus.Available,
    name:"codelist_status"
    })
    CodeListStatus:CodeListStatus;
  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
	default:"Admin",
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

 
}